import { useSelector } from 'react-redux';

import { StateSchema } from '../StoreProvider';

export const useAppSelector = useSelector.withTypes<StateSchema>();
